import PropTypes from 'prop-types';
import React, { useState, useRef, useEffect } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import paths from 'routes/paths';
import { useNavigate } from "react-router-dom";
import axios from 'helpers/api';
import * as mapYourMedsConstant from '../../common/mapYourMedsConstant.js';

const HcpSpecialityForm = (props) => {

    const initialFormData = {
        hcpspecial: "",
        isactive: true,
        id: ""
    };

    const [formData, setFormData] = useState(initialFormData);
    const formRef = useRef(null);
    const [buttonStatus, setButtonStatus] = useState(mapYourMedsConstant.ADD_ACTION);
    //const navigate = useNavigate();

    useEffect(() => {
        async function setHcpSpecialDetails() {
            //console.log("set edit details " + props.allergyvalue);
            const { speciality, is_active, speciality_id } = props.hcpsplvalue;
      
            setFormData({
                hcpspecial: speciality || "",
              isactive: is_active == 1 || is_active === true, // normalize boolean
              id: speciality_id || ""
            });

            setButtonStatus(mapYourMedsConstant.UPDATE_ACTION);
        }

        if (props.edittrigger > 0) {
            //console.log(props.trigger);
            setHcpSpecialDetails();
        }
    }, [props.edittrigger]);

    const handleSubmit = async e => {
        e.preventDefault();

        //console.log("ActiveFormData" + formData.isactive ? 1 : 0)

        let tokenStr = localStorage.getItem("accessToken");

        let pelmedsHcpSpecialityUrl = buttonStatus == mapYourMedsConstant.ADD_ACTION ? `${process.env.REACT_APP_SERVER_URL}` + "/doctors/add-doctor-speciality" : `${process.env.REACT_APP_SERVER_URL}` + "/doctors/edit-doctor-speciality";

        let pelmedsHcpSpecialityData = buttonStatus == mapYourMedsConstant.ADD_ACTION ? { "speciality": formData.hcpspecial, "is_active": formData.isactive ? 1 : 0 } :
            { "speciality": formData.hcpspecial, "is_active": formData.isactive ? 1 : 0, "id": formData.id }

        const { data } = await axios.post(pelmedsHcpSpecialityUrl, pelmedsHcpSpecialityData, { headers: { 'Authorization': `Bearer ${tokenStr}` } });

        if (data.status) {
            toast.success("Doctor Speciality added/updated successfully");
            //navigate(0);
        }
        else {
            toast.info("Error while adding doctor speciaility");
        }

        //if (props.status != "Edit") {
        setFormData(initialFormData);
        formRef.current.reset();
        setButtonStatus("Add");

        //}
        props.onCallParent();
    };

    const handleFieldChange = e => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    return (
        <Form ref={formRef} onSubmit={handleSubmit}>
            <Row>
                <Col xs={6}>
                    <Form.Group className="mb-3">
                        <Form.Label className="required">HCP Speciality</Form.Label>
                        <Form.Control
                            placeholder='HCP Speciality'
                            value={formData.hcpspecial}
                            name="hcpspecial"
                            onChange={handleFieldChange}
                            size="sm"
                            type="text"
                        />
                    </Form.Group>
                </Col>
                <Col xs={6}>
                    <Form.Group>
                        <Button
                            type="submit"
                            color="primary"
                            className="mt-4 w-50"
                            size="sm"
                            disabled={!formData.hcpspecial}>
                            {buttonStatus}
                        </Button>
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col xs={12}>
                    <Form.Group className="mb-3">
                        <Form.Check
                            type='switch'
                            name="isactive"
                            id='isactive'
                            checked={
                                formData.isactive
                            }
                            onChange={e =>
                                setFormData({
                                    ...formData,
                                    isactive: e.target.checked
                                })
                            }
                            label='Active'
                        />
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Form.Label><span className="text-danger">*</span> indicates required field</Form.Label>
                </Col>
            </Row>
        </Form>
    );
};
export default HcpSpecialityForm;

